'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Record } from 'immutable';
import ReportingMoneyRecord from './ReportingMoneyRecord';

const getCurrencyRecordOrFallback = (value, fallbackCurrencyCode) => {
  if (value === null) {
    return ReportingMoneyRecord();
  }

  if (typeof value === 'object') {
    return ReportingMoneyRecord(value);
  }

  return ReportingMoneyRecord({
    amount: value,
    currencyCode: fallbackCurrencyCode
  });
};

export default class ReportRecord extends Record({
  clickThroughRate: null,
  clickToContactRate: null,
  clicks: null,
  cost: null,
  costPerClick: null,
  costPerCustomer: null,
  costPerDeal: null,
  costPerLead: null,
  costPerMql: null,
  costPerNewContact: null,
  costPerOpportunity: null,
  costPerSession: null,
  costPerSql: null,
  customers: null,
  deals: null,
  dealsDetails: null,
  engagements: null,
  impressions: null,
  leads: null,
  likes: null,
  marketingQualifiedLeads: null,
  newContacts: null,
  opportunities: null,
  reach: null,
  revenue: null,
  roi: null,
  roiType: null,
  roiConverted: false,
  salesQualifiedLeads: null,
  keyResults: null,
  sessions: null,
  convertedCost: null,
  convertedRevenue: null,
  convertedCostPerNewContact: null,
  roiRevenue: null,
  roiCost: null,
  inconvertibleCurrencies: null,
  p25VideoViews: null
}) {
  constructor(report) {
    const {
      roi,
      convertedCost,
      convertedCostPerNewContact,
      convertedRevenue,
      cost,
      costPerClick,
      costPerCustomer,
      costPerDeal,
      costPerLead,
      costPerMql,
      costPerNewContact,
      costPerOpportunity,
      costPerSession,
      costPerSql,
      revenue,
      costCurrencyCode,
      portalCurrencyCode,
      revenueCurrencyCode,
      roiConverted
    } = report,
          data = _objectWithoutPropertiesLoose(report, ["roi", "convertedCost", "convertedCostPerNewContact", "convertedRevenue", "cost", "costPerClick", "costPerCustomer", "costPerDeal", "costPerLead", "costPerMql", "costPerNewContact", "costPerOpportunity", "costPerSession", "costPerSql", "revenue", "costCurrencyCode", "portalCurrencyCode", "revenueCurrencyCode", "roiConverted"]);

    super(Object.assign({
      roi: isNaN(roi) ? null : roi,
      convertedCost: getCurrencyRecordOrFallback(convertedCost, portalCurrencyCode),
      convertedCostPerNewContact: getCurrencyRecordOrFallback(convertedCostPerNewContact, portalCurrencyCode),
      convertedRevenue: getCurrencyRecordOrFallback(convertedRevenue, portalCurrencyCode),
      cost: getCurrencyRecordOrFallback(cost, costCurrencyCode),
      costPerClick: getCurrencyRecordOrFallback(costPerClick, roiConverted ? portalCurrencyCode : costCurrencyCode),
      costPerCustomer: getCurrencyRecordOrFallback(costPerCustomer, roiConverted ? portalCurrencyCode : costCurrencyCode),
      costPerDeal: getCurrencyRecordOrFallback(costPerDeal, roiConverted ? portalCurrencyCode : costCurrencyCode),
      costPerLead: getCurrencyRecordOrFallback(costPerLead, roiConverted ? portalCurrencyCode : costCurrencyCode),
      costPerMql: getCurrencyRecordOrFallback(costPerMql, roiConverted ? portalCurrencyCode : costCurrencyCode),
      costPerNewContact: getCurrencyRecordOrFallback(costPerNewContact, roiConverted ? portalCurrencyCode : costCurrencyCode),
      costPerOpportunity: getCurrencyRecordOrFallback(costPerOpportunity, roiConverted ? portalCurrencyCode : costCurrencyCode),
      costPerSession: getCurrencyRecordOrFallback(costPerSession, roiConverted ? portalCurrencyCode : costCurrencyCode),
      costPerSql: getCurrencyRecordOrFallback(costPerSql, roiConverted ? portalCurrencyCode : costCurrencyCode),
      revenue: getCurrencyRecordOrFallback(revenue, revenueCurrencyCode),
      roiRevenue: getCurrencyRecordOrFallback(roiConverted ? convertedRevenue : revenue, roiConverted ? portalCurrencyCode : revenueCurrencyCode),
      roiCost: getCurrencyRecordOrFallback(roiConverted ? convertedCost : cost, roiConverted ? portalCurrencyCode : costCurrencyCode),
      roiConverted
    }, data));
  }

}